import React, { createContext, useState } from "react";
import "./App.scss";
import ClaycoSecureApp from "clayco-secure-app";
import { useMsal } from "@azure/msal-react";
import Home from "./pages/home/home";
import { BrowserRouter } from "react-router-dom";
import { msalConfig, b2cMsalConfig, b2cProdConfig } from './auth-config';
import { reactPlugin } from "./utility/AppInsights";
import {AppInsightsContext} from '@microsoft/applicationinsights-react-js';
import { EmployeeNumberProvider } from "./employeeNumber";
import AuthenticatedChatbot from "./Components/AuthenticatedChatbot";


function App() {

    return (
        <div>
            <ClaycoSecureApp authConfig={msalConfig} >
                <AppInsightsContext.Provider value={reactPlugin}>
                    <EmployeeNumberProvider>
                    <BrowserRouter>
                        <div className="App">
                            <Home></Home>
                        </div>
                        </BrowserRouter>
                        </EmployeeNumberProvider>
                </AppInsightsContext.Provider>
                <AuthenticatedChatbot
                    title="Chat"
                    greeting="Hi! How can I help you today?"
                />
            </ClaycoSecureApp>
        </div>
    );
}

export default App;
